import { Fragment } from 'react'
import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import TutorOnDemand from '~/tutor-on-demand/pages/TutorOnDemand/TutorOnDemand.page'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import Metatags from '~/components/Metadata/Metatags'
import { getRunningQueriesThunk as getRunningHomInfoPromises, getHomInfo } from '~/redux/apis/hom-info-api'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { GetProps } from '~/utils/pageWrapper/types'

const TutorOnDemandIndexPage: NextPage = () => {
  const { t } = useTranslation('tutorOnDemand')
  const title = t('landingPage.title')
  return (
    <Fragment>
      <Metatags
        keywords={t('landingPage.keywords')}
        metaDescription={t('landingPage.metaDescription')}
        ogTitle={title}
        title={title}
      />

      <DefaultLayout zeroPadding>
        <TutorOnDemand />
      </DefaultLayout>
    </Fragment>
  )
}

export const getProps: GetProps = (store) => async () => {
  store.dispatch(getHomInfo.initiate())
  await Promise.all(store.dispatch(getRunningHomInfoPromises()))
  return {
    props: {
      namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'tutorOnDemand', 'landing'],
    },
  }
}

export const getStaticProps = getStaticPropsWrapper(getProps)

export default TutorOnDemandIndexPage
